import { MockRestCall } from "@/common/api/ApiResult.model";
import { RestCallsKey } from "@/mock/demo/rest.resolver";
import * as DATA from "./data.mock";

// @ts-ignore
export const mip_mock_calls: Record<RestCallsKey, MockRestCall> = {
  "mip-cognni-labels-ready-state": {
    delay: 100,
    payload: async () => "some",
  },
  "mip-get-cognni-labels": {
    delay: 100,
    payload: async () => {
      return DATA.LABELING_CONFIG_DATA.value;
    },
  },
  "get-mip-coggni-label-mapping": {
    delay: 100,
    payload: async () => {
      return DATA.LABEL_MAPPING_DATA.value.labelMappings;
    },
  },
  "mip-get-labels-tree": {
    delay: 100,
    payload: async () => {
      return {
        ...DATA.GET_LABELS_DATA,
        is_empty: false,
      };
    },
  },
  "mip-get-all-label-overrides": {
    delay: 100,
    payload: async () => {
      return DATA.LABEL_OVERRIDES_DATA.value.labelOverrides.filter(
        (l: any) => l.override
      );
    },
  },
  "get-mappable-labels": {
    delay: 100,
    payload: async () => [],
  },
};

// @ts-ignore
window.inject_mock_api(mip_mock_calls);
